exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cards-text[data-v-45ac841b]{word-wrap:break-word!important}.cards-favorite[data-v-45ac841b]{line-height:100%!important}.cards-image[data-v-45ac841b],.cards-image img[data-v-45ac841b]{width:100%}.static-cards[data-v-45ac841b]{padding-bottom:0}.static-cards .cards-bottom[data-v-45ac841b]{position:relative;height:auto}.static-cards .cards-bottom .topspace[data-v-45ac841b]{margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"33","vue":true,"id":"data-v-45ac841b","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/insurance-card.vue
// module id = KvC/
// module chunks = 0